export default {
  LOAD_STUDENT_CYCLES_START: 'LoadStudentCyclesStart',
  LOAD_STUDENT_CYCLES_END: 'LoadStudentCyclesEnd'
};